<template>
  <div class="wrap" v-loading="allLoading">
    <div class="main-wrap my-orders">
      <!-- 导航 -->
      <div class="top-area" ref="topBox">
        <div class="order-navigation">
          <a
            class="text1"
            href="/#/catalogue"
          >{{L.home}}</a>
          <span class="line">/</span>
          <!-- 我的订单 -->
          <a
            class="text2"
            href="/#/auth" 
          >{{L.authentication}}</a>
        </div>
        <div class="my-orders-title">
          <span class="title-text">{{L.authentication}}</span>
          <div class="btn-with-bg" @click="handleRefresh">
            <span class="iconfont icon-refresh">&#xe611;</span>
            <span>Refresh Verification Result</span>
          </div>
        </div>
      </div>
      <!-- 认证结果 -->
      <div class="result-wrapper">
        <!-- 还没认证 -->
        <div class="result-wrap result-fail" v-if="status=='UNAUTHENTICATED'">
          <img class="result-icon" src="../../assets/cry.png"/>
          <div class="result-content">
            <div class="result-text-success">{{L.verifyIncomplete}}</div>
            <div class="result-text-desc">{{L.fillVerify}}</div>
          </div>
        </div>
        <!-- 继续认证 -->
        <div class="result-wrap result-fail" v-if="status=='PROCESSING' && authUrl">
          <img class="result-icon" src="../../assets/cry.png"/>
          <div class="result-content">
            <div class="result-text-success">{{L.verifyIncomplete}}</div>
            <div class="result-text-desc">{{ L.continueVerify }}</div>
          </div>
        </div>
        <!-- 认证处理中 -->
        <div class="result-wrap result-processing" v-if="status=='PROCESSING' && !authUrl">
          <img class="result-icon" src="../../assets/waiting.png"/>
          <div class="result-content">
            <div class="result-text-success">{{L.waitingVerify}}</div>
            <div class="result-text-desc">{{L.pleseRefresh}}</div>
          </div>
        </div>
        <!-- 认证成功 -->
        <div class="result-wrap result-success" v-if="status=='AUTHORIZED'">
          <img class="result-icon" src="../../assets/smile.png"/>
          <div class="result-content">
            <div class="result-text-success">{{L.congratulationVerify}}</div>
            <div class="result-text-desc">{{L.companyVerify}}</div>
          </div>
        </div>
        <!-- 认证失败 -->
        <div class="result-wrap result-fail" v-if="status=='FAILED'">
          <img class="result-icon" src="../../assets/cry.png"/>
          <div class="result-content">
            <div class="result-text-success">{{L.verifyFailed}}</div>
            <div class="result-text-desc">{{failMessage}}</div>
          </div>
        </div>
      </div>
      <!-- <div class="tab">
        <div class="square-wrap" :class="{'square-wrap-active-half':status==0,'square-wrap-active':status>=1}">
          <div class="rule-square">
            <span class="text">
              <span class="iconfont icon-num" v-if="status==0">&#xe762;</span>
              <span class="iconfont icon-num icon-num2" v-if="status>=1">&#xe66e;</span>
              <span class="text-info">{{L.basicInfo}}</span>
            </span>
            <span class="right-triangle"></span>
          </div>
        </div>
        <div class="square-wrap" :class="{'square-wrap-active-half':status==1,'square-wrap-active':status>=2}">
          <div class="rule-square">
            <span class="text">
              <span class="iconfont icon-num" v-if="status==1">&#xe763;</span>
              <span class="iconfont icon-num icon-num2" v-if="status>=2">&#xe66e;</span>
              <span class="text-info">{{L.bankInfo}}</span>
            </span>
            <span class="left-triangle"></span>
            <span class="right-triangle"></span>
          </div>
        </div>
        <div class="square-wrap" :class="{'square-wrap-active-half':status==2,'square-wrap-active':status>=3}">
          <div class="rule-square">
            <span class="text">
              <span class="iconfont icon-num" v-if="status==2">&#xe764;</span>
              <span class="iconfont icon-num icon-num2" v-if="status>=3">&#xe66e;</span>
              <span class="text-info">{{L.amountVerification}}</span>
            </span>
            <span class="left-triangle"></span>
            <span class="right-triangle"></span>
          </div>
        </div>
        <div class="square-wrap" :class="{'square-wrap-active':status==3}">
          <div class="rule-square">
            <span class="text">
              <span class="iconfont icon-num icon-num2" v-if="status==3">&#xe66e;</span>
              <span class="text-info">{{L.authSuccessful}}</span>
            </span>
            <span class="left-triangle"></span>
          </div>
        </div>
      </div> -->
      <div class="line-title">
        <span class="title">Company Information</span>
        <div class="continuous-btn-no-bg">
          <div class="btn" v-if="status=='UNAUTHENTICATED' || status=='FAILED'" @click="saveInfo">{{L.saveCompany}}</div>
          <div class="btn" v-if="status=='UNAUTHENTICATED' || status=='FAILED'" @click="startVerify">{{L.startVerify}}</div>
          <div class="btn" v-if="status=='PROCESSING' && authUrl" @click="continueVerify">{{L.continueVerifyBtn}}</div>
        </div>
      </div>
      <div class="basic-info-wrap">
        <el-form class="auth-form" :model="info" :rules="rules" ref="authForm">
          <div class="inp-wrap">
            <div class="title-text">{{L.companyCode}}</div>
            <el-form-item prop="dealerCode">
              <el-input disabled size="mini" class="inp" v-model="info.dealerCode"></el-input>
            </el-form-item>
          </div>
          <div class="inp-wrap">
            <div class="title-text"><span class="asterisk">*</span>{{L.companyName}}</div>
            <el-form-item prop="dealerName">
              <el-input :disabled="!(status=='UNAUTHENTICATED' || status=='FAILED')" size="mini" class="inp" v-model="info.dealerName"></el-input>
            </el-form-item>
          </div>
          <div class="inp-wrap">
            <div class="title-text"><span class="asterisk">*</span>{{L.companyID}}</div>
            <el-form-item prop="taxNumber">
              <el-input :disabled="!(status=='UNAUTHENTICATED' || status=='FAILED')" size="mini" class="inp" v-model="info.taxNumber"></el-input>
            </el-form-item>
          </div>
          <div class="inp-wrap">
            <div class="title-text"><span class="asterisk">*</span>{{L.legalPersonName}}</div>
            <el-form-item prop="legalName">
              <el-input :disabled="!(status=='UNAUTHENTICATED' || status=='FAILED')" size="mini" class="inp" v-model="info.legalName"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <!-- 弹窗 -->
    <Verify ref="Verify" @afterClickVerify="afterClickVerify"/>
    <Jump ref="Jump" @closeWindow="closeWindow" />
  </div>
</template>

<script>
import {api_auth_info,api_auth_get_status,api_auth_modify_company_info} from '@/api/api'
import {postAction} from '@/api/tool'
import Verify from './Verify'
import Jump from './Jump'

export default {
  name:'Auth',
  components:{
    Verify,
    Jump
  },
  data(){
    return {
      status:'',
      authUrl:'',
      failMessage:'',
      info:{
        dealerCode:'',
        dealerName:'',
        taxNumber:'',
        legalName:''
      },
      rules:{
        dealerName:[{required:true, message:'Complete this field.', trigger:'blur'}],
        taxNumber:[{required:true, message:'Complete this field.', trigger:'blur'}],
        legalName:[{required:true, message:'Complete this field.', trigger:'blur'}]
      }
    }
  },
  methods:{
    getCompanyInfo(){
      this.allLoading=true
      postAction(api_auth_info).then(res=>{
        this.allLoading=false
        this.info=res
      }).catch(()=>{
        this.allLoading=false
      })
    },
    getAuthStatus(){
      postAction(api_auth_get_status).then(res=>{
        this.authUrl = res.authUrl
        this.status = res.status
        this.failMessage = res.message
      })
    },
    handleRefresh(){
      this.getCompanyInfo()
      this.getAuthStatus()
    },
    saveInfo(){
      this.$refs.Jump.open()
      this.$refs.authForm.validate((valid)=>{
        if(!valid){
          this.$message.warning('Please complete the required fields.')
          return
        }
        this.allLoading=true
        postAction(api_auth_modify_company_info,this.info).then(()=>{
          this.$message.success('Saved successfully')
          this.getCompanyInfo()
          this.allLoading=false
        }).catch(()=>{
          this.allLoading=false
        })
      })
    },
    closeWindow(){
      this.getCompanyInfo()
      this.getAuthStatus()
    },
    startVerify(){
      this.$refs.authForm.validate((valid)=>{
        if(!valid){
          this.$message.warning('Please complete the required fields.')
          return
        }
        this.$refs.Verify.open()
      })
    },
    afterClickVerify(){
      this.$refs.Jump.open()
    },
    continueVerify(){
      window.open(this.authUrl)
      this.$refs.Jump.open()
    },
    showBasic(){
      this.$refs.Verify.open()
    }
  },
  mounted(){
    this.getCompanyInfo()
    this.getAuthStatus()
  }
}
</script>

<style lang="less" scoped>
@import url('/public/css/public.less');
@import url('./index.less');
</style>

